// @flow
import React from 'react';
import type { Node } from 'react';
import TextField from '@material-ui/core/TextField';

type Props = $ReadOnly<{
    label: Node,
    className?: string
}>;

function Field({ label, input, meta, className }: Props) {
    return (
        <div className={className}>
            <TextField
                fullWidth
                label={label}
                variant="filled"
                margin="dense"
                error={meta.touched && !meta.valid}
                {...input}
            />
        </div>
    );
}

export default Field;